// Filtre til events fra api.school_user_events.read (docendo.schoolEvents).
//
// "Er vikar" afgøres af event.substitutes (calendar_events.substitute = true), ikke af
// substitute_for: man kan være vikar uden at dække for en bestemt lærer (fx gårdvagt, tur),
// og så er substitute_for null.

export function isSubstitute (event, userId) {
  return ((event && event.substitutes) || []).some(sub => sub && Number(sub.id) === Number(userId))
}

export function eventMatchesFilter (event, eventsFilter, userId) {
  switch (eventsFilter) {
    case null:
      return event.event_type !== ''
    case 'subject':
      return event.event_type !== 'absence' && event.event_type !== 'other_tasks' && event.event_type !== 'other_stuff' && !isSubstitute(event, userId)
    case 'substituteHours':
      return isSubstitute(event, userId)
    case 'absence':
      return event.event_type === 'absence'
  }
}

export function filterUserEvents (events, eventsFilter, userId) {
  return (events || []).filter(event => eventMatchesFilter(event, eventsFilter, userId))
}



// WEBPACK FOOTER //
// ./src/utils/userEventsFilter.js